import Quill from "quill";
const Parchment = Quill.import("parchment");
class lineHeightAttributor extends Parchment.StyleAttributor { }
const lineHeightStyle = new lineHeightAttributor("lineHeight", "line-height", {
    scope: Parchment.Scope.INLINE, whitelist: ["initial", "1", "1.5", "1.75", "2", "3", "4"]
});

export { lineHeightStyle };